module.exports = __webpack_public_path__ + "img/Group 96.517f604a.svg";